module.exports = __webpack_public_path__ + "static/media/ban.08c2746e.svg";